module.exports = __webpack_public_path__ + "static/img/房间风口.784af796.png";